<template>
  <div>
    <!-- {{ userList }} -->
    <el-table :data="userList" style="width: 100%" border height="calc(100vh - 360px)">
      <el-table-column prop="symbol" label="合约名" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.symbol.toUpperCase() }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="longPositionValue"
        label="多仓仓位价值(合计)"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <span>{{ scope.row.longPositionValue }}</span>
          <span class="tips">USDT</span>
        </template>
      </el-table-column> -->
      <el-table-column label="多仓仓位价值用户" prop="userLongPositionValue" align="center" sortable>
        <template slot-scope="scope">
          <!-- <div>
            <span>{{ scope.row.sysLongPositionValue }}</span>
            <span class="tips">USDT</span>
          </div> -->
          <div>
            <span>{{ scope.row.userLongPositionValue }}</span>
            <span class="tips">USDT</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="多仓仓位用户张数" prop="userLongPositionSize" align="center" sortable>
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.userLongPositionSize }}</span>
            <span class="tips">张</span>
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column
        prop="shortPositionValue"
        label="空仓仓位价值(合计)"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <span>{{ scope.row.shortPositionValue }}</span>
          <span class="tips">USDT</span>
        </template>
      </el-table-column> -->
      <el-table-column label="空仓仓位价值用户" prop="userShortPositionValue" align="center" sortable>
        <template slot-scope="scope">
          <!-- <div>
            <span>{{ scope.row.sysShortPositionValue }}</span>
            <span class="tips">USDT</span>
          </div> -->
          <div>
            <span>{{ scope.row.userShortPositionValue }}</span>
            <span class="tips">USDT</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="空仓仓位用户张数" prop="userShortPositionSize" align="center" sortable>
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.userShortPositionSize }}</span>
            <span class="tips">张</span>
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column
        prop="positionHeadInchValue"
        label="净头寸仓位价值(合计)"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <span>{{ scope.row.positionHeadInchValue }}</span>
          <span class="tips">USDT</span>
        </template>
      </el-table-column> -->

      <el-table-column label="净头寸仓位价值用户" prop="userPositionHeadInchValue" align="center" sortable>
        <template slot-scope="scope">
          <!-- <div>
            <span>{{ scope.row.sysPositionHeadInchValue }}</span>
            <span class="tips">USDT</span>
          </div> -->
          <div>
            <span>{{ scope.row.userPositionHeadInchValue }}</span>
            <span class="tips">USDT</span>
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleUpdate(scope.row)"
            v-if="scope.row.type == 0"
            >修改备注</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleUpdatePartner(scope.row, 0)"
            v-if="scope.row.rebateRate == 0 && scope.row.type == 0"
            >升级合伙人</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleRate(scope.row, 1)"
            v-if="scope.row.rebateRate != 0 && scope.row.type == 0"
            >设置返佣比例</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pag">
      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged">
      </pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";

export default {
  name: "giftCoinList",
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: "",
      selectedForUserType: {},
      textarea2: "",
      centerDialogVisible: false,
      partnerDialogVisible: false,
      input2: "",
      upgradeRateForm: {},
      title: "",
    };
  },
  components: {
    Pagination,
  },
  mounted() {
    this.getSymbolList();
  },
  methods: {
    ...mapActions("user", ["addRemark"]),
    ...mapActions("userTiger", ["getSymbolList"]),
    ...mapActions("headInch", ["upgradePartner", "upgradeRate"]),
    ...mapMutations("headInch", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
    ]),
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("添加成功");
          (this.textarea2 = ""), (this.centerDialogVisible = false);
          this.$emit("refresh");
        }
      });
    },
    addRate() {
      if (this.btnType == 0) {
        this.upgradePartner({
          channelId: this.userInfo.channelId,
          userId: this.upgradeRateForm.id,
          rate: Number(this.input2),
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success("申请合伙人成功");
            this.partnerDialogVisible = false;
            this.input2 = "";
            this.$emit("refresh");
          } else {
            this.$message.error(res.error.msg);
          }
        });
      }
      if (this.btnType == 1) {
        this.upgradeRate({
          channelId: this.userInfo.channelId,
          userId: this.upgradeRateForm.id,
          rate: Number(this.input2),
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success("设置返佣比例成功");
            this.partnerDialogVisible = false;
            this.input2 = "";
          } else {
            this.$message.error(res.error.msg);
          }
        });
      }
    },
    pageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    handleUpdate(row) {
      this.updateForm = { ...row };
      // this.setUserinfoDetail(selected);
      // this.setUserinfoDetailDialogVisible(true);

      this.centerDialogVisible = true;
      this.textarea2 = row.remarks;
    },
    handleUpdatePartner(row, type) {
      this.title = "升级合伙人";
      this.upgradeRateForm = { ...row };
      this.partnerDialogVisible = true;
      this.btnType = type;
    },
    handleRate(row, type) {
      this.title = "设置返佣比例";
      this.partnerDialogVisible = true;
      this.upgradeRateForm = { ...row };
      this.input2 = row.rebateRate * 100;
      this.btnType = type;
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(["userInfo"]),
    ...mapState("headInch", [
      "pagination",
      "userList",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
    ]),
  },
};
</script>

<style lang="less" src="../../../../../styles/button.less" scoped>
.pag {
  display: flex;
  justify-content: center;
}

.user-type-select {
  width: 100%;
}

.red {
  color: skyblue;
  font-weight: bold;
}

.cc {
  color: #97a0ff;
  font-weight: bold;
}

::v-deep.el-table th {
  font-weight: bold;
  color: #909399;
}
</style>
